'use client';

import React from 'react';
import { Menu } from '@miso/design-system';
import { LogoutIcon } from '@/shared/ui/display/EmojiIcon';
import { useAuth } from '@/entities/auth/model/useAuth';

const LOGIN_PATH = '/login';

/**
 * 로그아웃 메뉴 항목 — `<Menu.Item>` 형태.
 */
export function LogoutMenuItem() {
  const { logout } = useAuth();

  const handleLogout = async () => {
    if (!window.confirm('정말로 로그아웃 하시겠습니까?')) return;
    await logout();
    window.location.href = LOGIN_PATH;
  };

  return (
    <Menu.Item icon={<LogoutIcon fontSize="small" />} onClick={handleLogout}>
      로그아웃
    </Menu.Item>
  );
}
